export default "__VITE_ASSET__BxxHm5wy__"